export default "__VITE_ASSET__CHdxkbjn__"